import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function WhatsAppButton() {
  const [phone, setPhone] = useState('');

  useEffect(() => {
    axios.get('/api/landing-content').then(({ data }) => {
      const wa = data?.contact?.social?.whatsapp || '';
      if (wa) setPhone(wa.replace(/\D/g, ''));
    }).catch(() => {});
  }, []);

  if (!phone) return null;

  return (
    <>
      <style>{`
        @keyframes wa-pulse {
          0%   { box-shadow: 0 0 0 0 rgba(37,211,102,0.6); }
          70%  { box-shadow: 0 0 0 16px rgba(37,211,102,0); }
          100% { box-shadow: 0 0 0 0 rgba(37,211,102,0); }
        }
        .wa-btn { animation: wa-pulse 2s infinite; }
        .wa-btn:hover { transform: scale(1.08); box-shadow: 0 8px 30px rgba(37,211,102,0.5) !important; }
      `}</style>
      <a
        href={`https://wa.me/${phone}`}
        target="_blank"
        rel="noreferrer"
        className="wa-btn"
        title="WhatsApp ile iletişime geçin"
        style={{
          position: 'fixed',
          bottom: 24,
          right: 20,
          zIndex: 9999,
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'linear-gradient(135deg,#25d366,#128c7e)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'pointer',
        }}
      >
        <svg viewBox="0 0 32 32" style={{ width: 30, height: 30, fill: '#fff' }}>
          <path d="M16 1C7.716 1 1 7.716 1 16c0 2.628.673 5.1 1.854 7.253L1 31l8.003-1.832A14.941 14.941 0 0016 31c8.284 0 15-6.716 15-15S24.284 1 16 1zm0 27.333a12.294 12.294 0 01-6.274-1.713l-.45-.267-4.746 1.086 1.118-4.62-.293-.473A12.258 12.258 0 013.667 16C3.667 9.189 9.189 3.667 16 3.667S28.333 9.189 28.333 16 22.811 28.333 16 28.333zm6.715-9.208c-.368-.184-2.18-1.075-2.518-1.197-.337-.123-.583-.184-.828.184-.245.368-.95 1.197-1.164 1.442-.214.245-.429.276-.797.092-.368-.184-1.555-.573-2.962-1.828-1.095-.977-1.834-2.183-2.049-2.551-.214-.368-.023-.567.161-.75.166-.165.368-.429.552-.643.184-.214.245-.368.368-.613.123-.245.061-.46-.031-.643-.092-.184-.828-1.996-1.135-2.734-.299-.718-.603-.621-.828-.632l-.705-.012c-.245 0-.643.092-.979.46-.337.368-1.287 1.258-1.287 3.069s1.318 3.558 1.502 3.803c.184.245 2.594 3.962 6.288 5.557.879.379 1.564.606 2.099.776.882.281 1.685.241 2.319.146.707-.105 2.18-.891 2.488-1.752.307-.861.307-1.599.215-1.752-.092-.153-.337-.245-.705-.429z"/>
        </svg>
      </a>
    </>
  );
}
